import { AnimatePresence, motion } from 'framer-motion';
import CustomSpinner from '../../../../commonComponents/CustomSpinner';
import { Colors } from '../../../../themes/colors';
import { CardActionsHeader } from '../CardActionsHeader';
import { EmptyFilteredList } from '../EmptyFilteredList';
import { ProfessionalCard } from '../ProfessionalCard';
import { EmptyFavorites } from './EmptyFavorites';
import { ProfessionalCardActions } from './ProfessionalCardActions';
import { ProfessionalCardDetails } from './ProfessionalCardDetails';
import { useFavoritesList } from './hooks/useFavoritesList';

export const FavoritesList = () => {
  const { isLoading, favoriteProfessionals, isEmpty, isFiltered } = useFavoritesList();

  if (isLoading) {
    return <CustomSpinner isLoading size={24} />;
  }

  if (isEmpty) {
    if (isFiltered) {
      return <EmptyFilteredList />;
    }
    return <EmptyFavorites />;
  }

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <span
        style={{
          display: 'flex',
          fontFamily: 'Nunito',
          fontSize: '16px',
          fontStyle: 'italic',
          color: Colors.neutral_500,
          textAlign: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        You can manage your list of favorite professionals on this section of the Professionals Hub,
        <br />
        and directly invite them to your upcoming shifts!
      </span>

      <div
        style={{
          maxWidth: '827px',
          marginTop: 32,
          display: 'flex',
          justifyContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <motion.div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
          }}
          layout
        >
          <AnimatePresence>
            <CardActionsHeader actions={['Invite']} />
            {favoriteProfessionals?.map((professional) => (
              <ProfessionalCard
                key={professional.id}
                user={{
                  ...professional,
                  isFavorite: true,
                  rating: !professional?.averageProfessionalRating
                    ? undefined
                    : {
                        averageRating: professional?.averageProfessionalRating?.averageRating,
                        interpersonalSkills:
                          professional?.averageProfessionalRating?.averageInterpersonalSkills,
                        professionalSkills:
                          professional?.averageProfessionalRating?.averageProfessionalSkills,
                        timeManagement:
                          professional?.averageProfessionalRating?.averageTimeManagement,
                      },
                }}
                Details={ProfessionalCardDetails}
                Actions={ProfessionalCardActions}
                showRemoveIcon
              />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};
